import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"outlined":"","items":_vm.feeTypes,"label":_vm.$t('Type'),"hide-details":"auto"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }